
const rangeJson = 
[
  {
    "rangeId": "ss24_shakespearestheatre-muchadoaboutnothing",
    "name": "Shakespeare's Theatre - Much Ado About Nothing",
    "year": "2024",
    "releaseDate": "2024-03-15",
    "colors": [
      "lilac",
      "purple",
      "white"
    ],
    "themes": [
      "theatre",
      "shakespeare",
      "cat"
    ],
    "range": "limited & special edition",
    "version": 1,
    "edition": " Much Ado About Nothing",
    "series": "Shakespeares Theatre",
    "inLookbook": false
  }

]

export default rangeJson;
